import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

import * as $ from 'jquery';
@Injectable()
export class CommonService {
	imageUrl: any = '';
	surveyImageUrl: any = '';
	videoUrl : any = ''
	websiteurl: any;

	title = 'Dashboard'; //to activate the nav bar selected link
	constructor(private router: Router,private authService: AuthService,) {

		this.imageUrl = 'https://mywaz.com/api/UserProfile/';
		this.surveyImageUrl = 'https://mywaz.com/api/SurveyImages/';
		this.videoUrl =  "http://3.80.62.17:8087/videomain/"
		this.websiteurl = this.authService.website_url;

		// this.imageUrl = 'http://dev.waz.encoreskydev.com:5050/UserProfile/';
		// this.surveyImageUrl = 'http://dev.waz.encoreskydev.com:5050/SurveyImages/';
	}
	setTitle() {
		let obj = this;
		setTimeout(function () {
			switch (obj.router.url.replace('/', '')) {
				case '':
				case 'dashboard':
					obj.title = 'Dashboard';
					break;
				case 'user-list':
					obj.title = 'Users';
					break;
				case 'survey-list':
					obj.title = 'Surveys';
					break;
				case 'group-survey-list':
					obj.title = 'Group Surveys';
					break;
				case 'group-list':
					obj.title = 'Groups';
					break;
				case 'waz-view':
					obj.title = 'WAZ View';
					break;
				case 'notifications':
					obj.title = 'Notifications';
					break;
				case 'manage-profile':
					obj.title = 'My Profile';
					break;
				case 'change-password':
					obj.title = 'Change Password';
					break;
				case 'country-survey-list':
					obj.title = 'Country Surveys';
					break;
				case 'world-survey-list':
					obj.title = 'World Surveys';
					break;
				case 'group-list':
					obj.title = 'Groups';
					break;
				case 'language':
					obj.title = 'Language';
					break;
				case 'country':
					obj.title = 'Country';
					break;
				case 'setting':
					obj.title = 'Site Setting';
					break;
				case 'category':
					obj.title = 'Category';
					break;
				case 'waz-view-question':
					obj.title = 'WAZ View Questions';
					break;
				case 'pricing':
					obj.title = 'Survey Pricing';
					break;
				// default:
				// 	if(obj.router.url.indexOf('user-profile')>0)
				// 	obj.title = 'Score';

			}
		}, 500);
	}

	// Get option percentage
	optionPercentage = function (totalCount, optValue, optionLength, index) {
		if (Number(optValue)) {
			var percent = (Number(optValue) * 100) / totalCount;
			return percent.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
		}
		else {
			return 0;
		}
	}

	// Calculate Date Difference
	calculateExpiry = function (expiryTime) {
		this.surveyExpiryDate = new Date(expiryTime);
		this.currentDate = new Date();
		this.currentDate = new Date(this.currentDate.toISOString());
		var seconds = Math.floor((this.surveyExpiryDate - this.currentDate) / 1000);
		if (Math.round(seconds / (60 * 60 * 24 * 365.25)) >= 2) return Math.round(seconds / (60 * 60 * 24 * 365.25)) + " Years";
		// else if(Math.round(seconds/(60*60*24*365.25)) > 1) return "1 Year";
		else if (Math.round(seconds / (60 * 60 * 24 * 30.4)) >= 2) return Math.round(seconds / (60 * 60 * 24)) + " Days";
		else if (Math.round(seconds / (60 * 60 * 24)) >= 2) return Math.round(seconds / (60 * 60 * 24)) + " Days";
		else if (Math.round(seconds / (60 * 60 * 24)) >= 1 && Math.round(seconds / (60 * 60)) > 24) return "1 day ";
		else if (Math.round(seconds / (60 * 60)) >= 2) return Math.round(seconds / (60 * 60)) + " Hours";
		else if (Math.round(seconds / (60 * 60)) >= 1) return "1 Hour";
		else if (Math.round(seconds / 60) >= 2) return Math.round(seconds / 60) + " Minutes";
		else if (Math.round(seconds / 60) >= 1) return "1 Minute";
		else if (seconds >= 2) return seconds + " Seconds";
		else if (seconds >= 1) return seconds + "1 Second";
		else return 'Few Seconds';
	};

	// Set default image if image has error
	defaultUrl(event) {
		event.target.src = '../../../assets/img/default-avatar.png';
	}

	// Show body loader
	process = function () {
		$('.loader').show();
	}
	// Hide body loader
	hideProcess = function () {
		$('.loader').hide();
	}

	// Get date
	getDate = function (ISODate) {
		var date = new Date(ISODate);
		return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
	}



	loadScript = function () {
		return new Promise((resolve, reject) => {
			const scriptElement = document.createElement('script')
			scriptElement.src = this.websiteurl + '/assets/js/material-bootstrap-wizard.js';
			scriptElement.onload = resolve
			document.body.appendChild(scriptElement)
		});
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/services/common.service.ts